export const SET_ACTIVE_FILTERS_FROM_SEARCH_QUERY =
  "hire_a_team/set-active-filters-from-search-query";
export const SET_ACTIVE_FILTERS = "hire_a_team/set-active-filters";
export const TOGGLE_FILTER = "hire_a_team/toggle-filter";
export const PRESELECT_FILTER = "hire_a_team/preselect-filter";
export const POPULATE_FILTERS = "hire_a_team/populate-filters";
export const POPULATE_PRODUCTS = "hire_a_team/populate-products";
export const POPULATE_NEXT_PRODUCT_PAGE = "hire_a_team/populate-next-product-page";
export const ACTIVE_FILTER_NUM = "hire_a_team/active-filters-num";
export const ACTIVATE_PRESELECTED_FILTER = "hire_a_team/activate-preselected-filter";
export const ACTIVATE_ALL_PRESELECTED_FILTERS = "hire_a_team/activate-all-preselected-filters";
export const CLEAR_ALL_FILTERS = "hire_a_team/clear-all-filters";
export const CLEAR_ALL_PRESELECTED_FILTERS = "hire_a_team/clear-all-preselected-filters";
export const DESELECT_FILTERS = "hire_a_team/deselect-filters";
export const RESET = "hire_a_team/reset";
export const CLEAR_NON_TOPIC_FILTERS = "hire_a_team/clear-non-topic-filters";
export const HAS_RECOMMENDED = "hire_a_team/has-recommended";
